import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const StaffColleaguesInfoCard = (props) => {

    return (
        <div className={`d-flex align-items-start justify-content-between flex-wrap`}>
            {
                props.consultant ?
                    props.staffConsultantData?.map(data => (
                        <div key={data.id} className={`p-3 mb-4 d-flex align-items-center justify-content-center ${styles.total_staff_colleagues_card_box}`}>
                            <img className={`${styles.image_staff_colleagues_card_box}`} loading="lazy" src={`https://backdev.azrmelk.com${data.imageUrl}`} alt="avatar" />
                            <div className={`text-right me-3`}>
                                <h4 className={`pb-2 ${styles.title_staff_card_box}`}> {data.name + " " + data.family} </h4>
                                <span className={`${styles.subTitle_staff_card_box}`} style={{ color: "#8D8D8D" }}> تاریخ عضویت: </span>
                                <span className={`${styles.subTitle_staff_card_box}`} style={{ color: "#363636" }}> {data.registerDate.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                            </div>
                            <Link to={{
                                pathname: `/staff-managment-colleagues-info-card-detail/${data.id}`,
                                state: data
                            }} style={{ color: "#21409a" }} className={`me-auto align-self-end ${styles.link_icon_text}`}>
                                بیشتر
                                <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
                            </Link>
                        </div>
                    ))
                    :
                    props.staffColleaguesData?.map(data => (
                        <div key={data.id} className={`p-3 mb-4 d-flex align-items-center justify-content-center ${styles.total_staff_colleagues_card_box}`}>
                            <img className={`${styles.image_staff_colleagues_card_box}`} loading="lazy" src={`https://backdev.azrmelk.com/images/users/avatar/${data.avatarName}`} alt="avatar" />
                            <div className={`text-right me-3`}>
                                <h4 className={`pb-2 ${styles.title_staff_card_box}`}> {data.fullName} </h4>
                                <span className={`${styles.subTitle_staff_card_box}`} style={{ color: "#8D8D8D" }}> شماره موبایل: </span>
                                <span className={`${styles.subTitle_staff_card_box}`} style={{ color: "#363636" }}> {data.phoneNumber.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                            </div>
                            <Link to={{
                                pathname: `/staff-managment-colleagues-info-card-detail/${data.id}`,
                                state: data
                            }} style={{ color: "#21409a" }} className={`me-auto align-self-end ${styles.link_icon_text}`}>
                                بیشتر
                                <img className="p-2" src={arrowBlue} alt="arrow-left-blue" width="29" />
                            </Link>
                        </div>
                    ))
            }
        </div>
    )
}

export default StaffColleaguesInfoCard